import { render, staticRenderFns } from "./zfbAuthentication.vue?vue&type=template&id=65540250&scoped=true&"
import script from "./zfbAuthentication.vue?vue&type=script&lang=js&"
export * from "./zfbAuthentication.vue?vue&type=script&lang=js&"
import style0 from "./zfbAuthentication.vue?vue&type=style&index=0&id=65540250&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65540250",
  null
  
)

export default component.exports